import React, { useState } from 'react'
import Accordion from 'react-bootstrap/Accordion'
import Card from 'react-bootstrap/Card'
import FontAwesome from 'react-fontawesome'
import I18n from 'resources/i18n/I18n'
import Logo from '../logo/Logo'
import Title from '../typo/Title'
import ModalCreation from './ModalCreation'
import ModalDelete from './ModalDelete'
import ModalEdition from './ModalEdition'
import './configuration.scss'

const LabelEditionTree = ({ items, error, createLabel, editLabel, deleteLabel }) => {
  const [showModalCreation, setShowModalCreation] = useState(false)
  const [showModalDelete, setShowModalDelete] = useState(false)
  const [showModalEdition, setShowModalEdition] = useState(false)
  const [itemToCreate, setItemToCreate] = useState(null)
  const [itemToEdit, setItemToEdit] = useState(null)
  const [itemToDelete, setItemToDelete] = useState(null)

  const toggleModalCreation = () => setShowModalCreation(!showModalCreation)
  const toggleModalDelete = () => setShowModalDelete(!showModalDelete)
  const toggleModalEdition = () => setShowModalEdition(!showModalEdition)

  const onCreateLabel = (e, item) => {
    if (e) {
      e.stopPropagation()
    }
    setItemToCreate({ idParent: item.id })
    toggleModalCreation()
  }

  const onLabelCreation = (label) => {
    const category = { ...itemToCreate, label: label }
    createLabel(category)
    setItemToCreate(null)
  }

  const onDeleteLabel = (item) => {
    setItemToDelete(item)
    toggleModalDelete()
  }

  const deleteLabelHandler = () => {
    deleteLabel(itemToDelete)
    setItemToDelete(null)
  }

  const onModifyItemLabel = (label) => {
    setItemToEdit((prevState) => ({ ...prevState, label: label }))
  }

  const onEditLabel = (item) => {
    setItemToEdit(item)
    toggleModalEdition()
  }

  const editLabelHandler = () => {
    editLabel(itemToEdit)
    setItemToEdit(null)
  }

  const renderItems = (item) => {
    return item.subtypes.map((child) => (
      <Accordion.Collapse key={child.id} eventKey={item.id}>
        <Card.Body>
          <div className="configuration container d-flex justify-content-between align-items-center m-0">
            <span className="category-subtitle">{child.label}</span>
            <div className="d-flex">
              <div className="action-button small" onClick={() => onDeleteLabel(child)}>
                <FontAwesome name="trash" />
              </div>
              <div className="action-button small" onClick={() => onEditLabel(child)}>
                <FontAwesome name="pencil" />
              </div>
            </div>
          </div>
        </Card.Body>
      </Accordion.Collapse>
    ))
  }

  return (
    <div className="container-fluid">
      <Logo />
      <div className="container">
        <div className="row">
          <Title text={I18n.t('ConfigurationTitle')} />
        </div>
        <div className="row">
          <p className="error text-center"> {error} </p>
          <Accordion>
            {items &&
              items.map((item) => (
                <Card key={item.id}>
                  <Accordion.Toggle as={Card.Header} eventKey={item.id}>
                    <div className="d-flex justify-content-between align-content-center">
                      <span>{item.label}</span>
                      <div className="action-button small" onClick={(e) => onCreateLabel(e, item)}>
                        <FontAwesome name="plus" />
                      </div>
                    </div>
                  </Accordion.Toggle>
                  {renderItems(item)}
                </Card>
              ))}
          </Accordion>
        </div>
      </div>
      <ModalCreation showModal={showModalCreation} toggleModal={toggleModalCreation} createLabel={onLabelCreation} />
      <ModalEdition
        showModal={showModalEdition}
        toggleModal={toggleModalEdition}
        item={itemToEdit}
        editLabel={editLabelHandler}
        modifyItemLabel={onModifyItemLabel}
      />
      <ModalDelete showModal={showModalDelete} toggleModal={toggleModalDelete} deleteLabel={deleteLabelHandler} />
    </div>
  )
}

export default LabelEditionTree
